<template>
  <div>
    <AlertMessages v-if="alertValue" :alert-type="alertType" :alert-msg="alertMsg" @reset="alertValue = false" />
    <v-row>
      <v-col :cols="mobile() ? '12' : '11'" class="mx-auto pb-0">
        <v-breadcrumbs v-if="workflow.attributes" class="font-weight-medium px-0 d-inline" data-testid="workflows-breadcrumb" :class="mobile() ? 'workflow-breadcrumbs-mobile' : 'workflow-breadcrumbs'">
          <v-breadcrumbs-item
            active-class
            :to="{ path: '/workflows'}"
          >
            {{ $t('workFlows') }}
        </v-breadcrumbs-item >
        <v-icon>mdi-chevron-right</v-icon>
        <v-breadcrumbs-item
          disabled
        >
          {{ workflow.attributes.title }}
        </v-breadcrumbs-item>
      </v-breadcrumbs>
      <span class="float-right">
          <v-menu v-if="mobile()" offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="px-5 py-2" height="100%" icon v-bind="attrs" v-on="on">
                <v-icon large>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list class="menulist-drawer" data-testid="menu-list">
              <v-list-item @click="showWorkflowOverview" :class="page == 'overview' ? 'accent--text' : ''">
                <v-list-item-title>{{ $t("overview") }}</v-list-item-title>
              </v-list-item>
              <v-list-item @click="showWorkflowMembers" :class="page == 'members' ? 'accent--text' : ''">
                <v-list-item-title>{{ $t("people") }}</v-list-item-title>
                <v-chip small color="disabled" text-color="greytext" class="mx-2 px-2">
                  {{ workflowPeopleStatistics.participant_count }}
                </v-chip>
              </v-list-item>
            </v-list>
          </v-menu>
        </span>
      </v-col>
    </v-row>
    
    <v-row v-if="!loadingStore && workflow.attributes">
      <v-col cols="12" class="mr-auto ml-0 pb-0">
        
        <p v-if="workflowId == workflow.id"
        :class="
          mobile()
            ? 'text-h5 font-weight-bold ml-16 mr-16'
            : 'text-h5 font-weight-bold'
        " :align="mobile() ? 'center' : 'left'">
          {{ workflow.attributes.title }}
        </p>
      </v-col>
      <v-col v-if="!mobile()" cols="11" class="mr-auto ml-0 custom-tab-menu py-0">
        <v-list class="py-0" flat>
          <v-list-item @click="showWorkflowOverview" :class="page == 'overview' ? 'accent--text' : ''">{{ $t("overview") }}
          </v-list-item>
          <v-list-item @click="showWorkflowMembers" :class="page == 'members' ? 'accent--text' : ''">
            {{ $t("people") }}
            <v-chip small color="disabled" text-color="greytext" class="mx-2 px-2">
              {{ workflowPeopleStatistics.participant_count }}
            </v-chip>
          </v-list-item>
          <!--<v-list-item @click="showWorkflowOwners" :color="page == 'boosters' ? 'accent' : ''">{{ $t("owners") }}
            <v-chip small color="disabled" text-color="greytext" class="mx-2 px-2">
              {{ workflowPeopleStatistics.booster_count }}
            </v-chip>
          </v-list-item>-->
        </v-list>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import i18n from '../../plugins/i18n'
import AlertMessages from '../../components/AlertMessages'
import { repeatedMethodsMixin } from "../../mixins/repeatedMethodsMixin";

export default {
  components: {
    AlertMessages,
  },
  mixins: [repeatedMethodsMixin],
  props: {
    page: {
      type: String,
      default: 'overview'
    }
  },
  data() {
    return {
      valid: true,
      alertMsg: "",
      alertType: "",
      alertValue: false,
      workflowId: this.$route.params.id,
      loadingStore: false
    };
  },
  computed: {
    productPlan() {
      return this.$store.state.productPlan;
    },
    workflowPeopleStatistics() {
      return this.$store.state.peopleWorkflowStatistics
    },
    workflow() {
      return this.$store.state.workflow
    }
  },
  mounted() {
    this.loadingStore = true
    this.getWorkflow()
    this.getWorkflowUsersStatistics()
    this.loadingStore = false
  },
  methods: {
    showWorkflowOverview() {
      if (this.$route.name != 'WorkflowOverview') {
        this.$router.push({ path: '/workflow/' + this.workflowId })
      }
    },
    showWorkflowMembers() {
      if (this.$route.name != 'PeopleInWorkflow') {
        this.$router.push({ path: '/workflow/' + this.workflowId + '/people' })
      }
    },
    /*showWorkflowOwners() {
      if (this.$route.name != 'BoostersInWorkflow') {
        this.$router.push({ path: '/workflow/' + this.workflowId + '/owners' })
      }
    },*/
    getWorkflowUsersStatistics() {
      this.$store.dispatch("getWorkflowUsersStatistics", this.workflowId).catch(() => {
        this.alertValue = true
        this.alertType = 'error'
        this.alertMsg = i18n.t('serverError')
      })
    },
    async getWorkflow() {
      if(this.$store.state.workflow && this.$store.state.workflow.id == this.workflowId)
      {
        //nothing for now
      }else {
        this.$store.dispatch("getWorkflow", this.workflowId)
        .catch(error => {
          if (error.response.status == 403) {
            this.$router.push({ name: 'PageAccessDenied' })
          }
          if (error.response.status == 404) {
            this.$router.push({ name: 'PageNotFound' })
          } else {
            this.alertValue = true
            this.alertType = 'error'
            this.alertMsg = i18n.t('serverError')
          }
        })
      }
    },
  },
};
</script>


